import { BrandLink } from "../components/BrandLink";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LanguageSwitcher } from "../components/LanguageSwitcher";
import { AuthForm } from "../components/AuthForm";
import { useEmailAuth, codeFirst } from "../hooks/useEmailAuth";
import { getSandboxDraft, HANDOFF_PATH } from "../lib/sandboxDraft";

export { codeFirst };

export default function AuthPage() {
  // ?preview=sent&email=… renders the "check your email" step without sending (UI testing only; verifying still needs a real code)
  const preview = new URLSearchParams(window.location.search);
  const { session } = useAuth();
  const navigate = useNavigate();

  const [next] = useState(() => { const q = new URLSearchParams(window.location.search).get("next"); if (q && q.startsWith("/")) localStorage.setItem("dropit-next", q); const n = localStorage.getItem("dropit-next"); return n && n.startsWith("/") ? n : "/app"; });
  // a pending sandbox draft wins over the default destination (the magic link opens /auth in a new tab; localStorage is shared)
  const goNext = () => { localStorage.removeItem("dropit-next"); navigate(getSandboxDraft() && next === "/app" ? HANDOFF_PATH : next, { replace: true }); };
  useEffect(() => { if (session) goNext(); }, [session]); // eslint-disable-line react-hooks/exhaustive-deps

  const auth = useEmailAuth({ onSuccess: goNext, initialEmail: preview.get("preview") === "sent" ? preview.get("email") || "" : "", initialSent: preview.get("preview") === "sent" });

  return (
    <main className="screen-center px-5">
      <div className="fixed top-4 right-4 z-10"><LanguageSwitcher /></div>
      <section className="w-full max-w-sm fade-up" data-testid="auth-page">
        <div className="flex items-center gap-2 mb-8"><BrandLink to="/" size={22} testid="auth-brand-link" /></div>
        <AuthForm auth={auth} />
      </section>
    </main>
  );
}
